export const wrapperVariants = {
    initial: {

    }, animate: {
        transition: {
            staggerChildren: 0.075
        }
    }, exit: {

    }
}

export const wordVariants = {
    initial : {
        opacity: 0,
        filter: "blur(10px)"
    }, animate: {
        opacity: 1,
        filter: "blur(0px)",
        transition: {
            duration: 1.5,
            ease: [0.16, 1, 0.3, 1]
        }
    }, exit: {
        opacity: 0
    }
}